import {
    LIST_OAT_DATA_REQUEST,
    LIST_OAT_DATA_SUCCESS,
    LIST_OAT_DATA_FAILURE
} from "../../../constants"

const initialState = {
    data: null,
    loading: false,
    error: null,
    type: null,
};

const OATListFetcherReducer = (state = initialState, action) => {
    switch (action.type) {
        case LIST_OAT_DATA_REQUEST:
            return {
                ...state,
                loading: true,
                data: null,
                error: null,
                type: action.types,
            };
        case LIST_OAT_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                type: action.types,
                error: null,
            };
        case LIST_OAT_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                type: action.types,
                data: null,
            };
        default:
            return state;
    }
};

export default OATListFetcherReducer;
